import styled from 'styled-components';

// CONSTANTS
import { MAIN_BLACK, WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  background-color: ${p => p.bgColor || MAIN_BLACK};
  min-height: 425px;

  > * {
    color: ${p => p.bgColor || WHITE};
  }

  .page-content {
    position: relative;
  }

  .hero {
    &__breadcrumbs {
      position: absolute;
      top: 26px;
      left: 15px;
      color: ${p => p.color || WHITE};
    }

    &__subtitle {
      text-transform: uppercase;
      letter-spacing: 7px;
      margin-bottom: 15px;

      ${breakpoints.down('xs')} {
        text-align: center;
      }
    }

    &__title {
      margin-bottom: 30px;

      ${breakpoints.down('sm')} {
        margin-bottom: 15px;
      }
    }

    &__description {
      margin-bottom: 10px;
    }

    &__left-content {
      display: flex;
      flex-direction: column;
      justify-items: center;
      padding: 100px 0 70px;

      ${breakpoints.down('sm')} {
        padding: 80px 0 40px;
      }

      ${breakpoints.down('xs')} {
        padding-bottom: 0;
      }
    }

    &__right-section {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
`;

export default Container;
